import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const AdminRoute = ({ children }) => {
  const { token, user } = useSelector((state) => state.user);

  if (!token) {
    return <Navigate to={"/auth"} />;
  }

  if (user.role !== "admin" && token) {
    return <Navigate to="/user" />; // redirect normal user
  }

  return children;
};

export default AdminRoute;
